import { render, staticRenderFns } from "./LettresEdit.vue?vue&type=template&id=4afdf5b8&scoped=true"
import script from "./LettresEdit.vue?vue&type=script&lang=js"
export * from "./LettresEdit.vue?vue&type=script&lang=js"
import style0 from "./LettresEdit.vue?vue&type=style&index=0&id=4afdf5b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afdf5b8",
  null
  
)

export default component.exports